module.exports = __webpack_public_path__ + "img/card.5711b692.svg";